import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_BILLING_PAYMENTS: DyTableColumn[] = [
  //{ dataKey: 'id', label: 'ID', width: 50, type: 'number' },
  { dataKey: 'doS', label: 'DoS', width: 200, type: 'date' },
  { dataKey: 'appointmentType', label: 'Appt. Type', width: 300, type: 'text' },
  { dataKey: 'dueSince', label: 'Due Since', width: 150, type: 'number' },
  { dataKey: 'serviceCode', label: 'Service Code', width: 200, type: 'number' },
  { dataKey: 'fee', label: 'Fee', width: 150, type: 'currency' },
  {
    dataKey: 'billedInsPortion',
    label: 'Ins. Portion',
    width: 150,
    type: 'currency',
    background: '#FAE9D3',
    textColor: '#E96E29',
  },
  {
    dataKey: 'billedPatPortion',
    label: 'Pat. Portion',
    width: 150,
    type: 'currency',
    background: '#FAE9D3',
    textColor: '#E96E29',
  },
  {
    dataKey: 'totalBilled',
    label: 'Total Billed',
    width: 150,
    type: 'currency',
    background: '#FAE9D3',
    textColor: '#E96E29',
  },
  // {
  //   dataKey: 'billedNetDue',
  //   label: 'Net Due',
  //   width: 150,
  //   type: 'currency',
  //   background: '#FAE9D3',
  //   textColor: '#E96E29',
  // },
  {
    dataKey: 'paidInsPortion',
    label: 'Ins. Paid',
    width: 150,
    type: 'currency',
    background: '#F5D8DC',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'paidPatPortion',
    label: 'Pat. Paid',
    width: 150,
    type: 'currency',
    background: '#F5D8DC',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'netPaid',
    label: 'Total Paid',
    width: 150,
    type: 'currency',
    background: '#F5D8DC',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'totalWriteOff',
    label: 'WriteOff',
    width: 150,
    type: 'currency',
    background: '#F5D8DC',
    textColor: '#F03C9D',
  },
   {
    dataKey: 'totalAdjustment',
    label: 'Adjustment',
    width: 150,
    type: 'currency',
    background: '#F5D8DC',
    textColor: '#F03C9D',
  },
  {
    dataKey: 'dueInsPortion',
    label: 'Ins. Due',
    width: 150,
    type: 'currency',
    background: '#D8E4FF',
    textColor: '#7A3CDE',
  },
  {
    dataKey: 'duePatPortion',
    label: 'Pat. Due',
    width: 150,
    type: 'currency',
    background: '#D8E4FF',
    textColor: '#7A3CDE',
  },
  {
    dataKey: 'netDue',
    label: 'Net Due',
    width: 150,
    type: 'currency',
    background: '#D8E4FF',
    textColor: '#7A3CDE',
  },
];
